import React from "react";

const CollapseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
      <path
        d="M5.03362 15.5039V13.0953H2.625V11.9703H6.15862V15.5039H5.03362ZM11.8485 15.5039V11.9703H15.3821V13.0953H12.9735V15.5039H11.8485ZM2.625 6.28753V5.16253H5.03362V2.75391H6.15862V6.28753H2.625ZM11.8485 6.28753V2.75391H12.9735V5.16253H15.3821V6.28753H11.8485Z"
        fill="black"
      />
    </svg>
  );
};

export default CollapseIcon;
